import React from "react";
import { Typography } from "@mui/material";

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <Typography color="error" variant="h6" align="center">
    {message}
  </Typography>
);

export default ErrorMessage;
